import { ReactNode, useEffect, useState } from 'react';
import useExternalSearch from '~/apps/smartsend/components/smartsend/client/useExternalSearch';
import { captureException } from '~/lib/metrics';

interface props {
  children: ReactNode;
}

export default function SearchInitialiser({ children }: props) {
  const [loading, setLoading] = useState(true);
  const { getExternalSearchCredentials } = useExternalSearch();
  useEffect(() => {
    const load = async () => {
      // The token call is bounded by a timeout now, and a failed or timed-out call must not hold
      // the app blank. It used to escape as an unhandled rejection; it is reported here instead.
      try {
        await getExternalSearchCredentials();
      } catch (e) {
        captureException(e, 'Search token request failed', { 'search-stage': 'initialiser' });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return null;
  }

  return <>{children}</>;
}
